module.exports = __webpack_public_path__ + "2e6f06fce8149b990852820ce40de399.jpg";